import {testIdProps} from '@github-ui/test-id-props'
import {Box} from '@primer/react'
import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'

const containerStyles: BetterSystemStyleObject = {
  position: undefined,
  right: undefined,
  bottom: undefined,
  marginLeft: 1,
  width: 12,
  height: 12,
  border: '2px solid',
  borderRadius: 100,
  borderColor: 'canvas.default',
  backgroundColor: 'accent.fg',
  transform: 'translate(-2px, 2px)',
}

export const UnreadIndicator = () => {
  return (
    <Box sx={containerStyles}>
      <span className="sr-only" {...testIdProps('listview-item-unread-indicator')}>
        New activity.
      </span>
    </Box>
  )
}

try{ UnreadIndicator.displayName ||= 'UnreadIndicator' } catch {}